import DATA_POPULATION_AGE from './data/population-by-age.csv'

export const PALETTE = {
  get ACCENT() {
    return window
      .getComputedStyle(document.body)
      .getPropertyValue('--accent')
      .trim()
  },
  get BLUE() {
    return window
      .getComputedStyle(document.body)
      .getPropertyValue('--blue')
      .trim()
  },
}

export const CHAPTER_POPULATION_AGE = 'population-by-age'
export const CHAPTER_POPULATION_ETHNICITY = 'population-by-ethnicity'
export const CHAPTER_WATER = 'water'
export const CHAPTER_TRAFFIC = 'traffic'
export const CHAPTER_HEALTH = 'health'
export const CHAPTER_EDUCATION = 'education'
export const CHAPTERS = [
  CHAPTER_POPULATION_AGE,
  CHAPTER_POPULATION_ETHNICITY,
  CHAPTER_WATER,
  CHAPTER_TRAFFIC,
  CHAPTER_HEALTH,
  CHAPTER_EDUCATION,
]

export const FIRST_DATASET = DATA_POPULATION_AGE

export const UNIT_PEOPLE = 'people'
export const UNIT_GALLONS = 'acre-feet'
export const UNIT_MINUTES = 'minutes'
export const UNIT_PERCENTAGE = '%'
export const UNIT_DEATHS = 'deaths per 100,000'
export const UNITS = {
  [CHAPTER_POPULATION_AGE]: UNIT_PEOPLE,
  [CHAPTER_POPULATION_ETHNICITY]: UNIT_PEOPLE,
  [CHAPTER_WATER]: UNIT_GALLONS,
  [CHAPTER_TRAFFIC]: UNIT_MINUTES,
  [CHAPTER_HEALTH]: UNIT_PERCENTAGE,
  [CHAPTER_EDUCATION]: UNIT_PEOPLE,
}

export const DATATYPE_RATIO = 'ratio'
export const DATATYPE_CUMULATIVE = 'cumulative'
export const DATATYPES = {
  [CHAPTER_POPULATION_AGE]: DATATYPE_RATIO,
  [CHAPTER_POPULATION_ETHNICITY]: DATATYPE_RATIO,
  [CHAPTER_WATER]: DATATYPE_CUMULATIVE,
  [CHAPTER_TRAFFIC]: DATATYPE_CUMULATIVE,
  [CHAPTER_HEALTH]: DATATYPE_CUMULATIVE,
  [CHAPTER_EDUCATION]: DATATYPE_CUMULATIVE,
}

export const LEGENDS = {
  [CHAPTER_POPULATION_AGE]: 'Decrease/increase of population',
  [CHAPTER_POPULATION_ETHNICITY]: 'Decrease/increase of population',
  [CHAPTER_WATER]: 'Gallons of water',
  [CHAPTER_TRAFFIC]: 'Minutes for a 20 minutes trip',
  [CHAPTER_HEALTH]: '% of people',
  [CHAPTER_EDUCATION]: 'People',
}

export const DESCRIPTIONS = {
  [CHAPTER_POPULATION_AGE]: `This data comes from the Texas Demographic Center. Based on the migration trends between 2010-2015 of people coming to Texas from other U.S. states and non-U.S. countries, it projects population estimates for each county up to the year 2050.`,
  [CHAPTER_POPULATION_ETHNICITY]: `This data comes from the Texas Demographic Center. Based on the migration trends between 2010-2015 of people coming to Texas from other U.S. states and non-U.S. countries, it projects population estimates for each county up to the year 2050.`,
  [CHAPTER_WATER]: `This data comes from the Texas Water Development Board. It projects the needs of water user groups in the state – municipal, irrigation, manufacturing, livestock, mining, and steam-electric power – under a scenario where Texas experiences a drought of record similar to the one it suffered during the 1950s.`,
  [CHAPTER_TRAFFIC]: `This data comes from the Texas A&M Transportation Institute and is known as the "Planning Time Index".It shows how much additional time a commuter needs to plan to add to their trip in heavy traffic if the same trip in light traffic takes 20 minutes.`,
  [CHAPTER_HEALTH]: `This data comes from the County Health Rankings & Roadmaps, a collaboration between the Robert Wood Johnson Foundation and the University of Wisconsin Population Health Institute. The project provides rankings for each county in the United States that measure crucial health factors influenced by how we live, learn, work, and play.`,
  [CHAPTER_EDUCATION]: `This data comes from the U.S. Census' American Community Survey (5-Year Estimates) and shows estimates for various levels of educational attainment in each of our state's 254 counties.`,
}

// checked manually, I know this is so shit 😵
// TODO do this in node, it's too heavy on the frontend
export const MAX_RATIO = {
  [CHAPTER_POPULATION_AGE]: 12.333223385833264,
  [CHAPTER_POPULATION_ETHNICITY]: 31.581518540317834,
}

export const SINGLE_CATEGORY_STRING = 'value'
export const CATEGORY_STRING = 'category_'
export const NO_DATA_STRING = 'N/A'
export const TEXAS_STATE = 'State Of Texas'
export const CATEGORY_PREMATURE_DEATHS = `${CATEGORY_STRING}Premature deaths`

export const MAP_ANIMATION_DURATION = 500
export const TIMELINE_HEIGTH = 80
export const SLIDES_PROGRESS_BAR_HEIGTH = 10
export const TIMELINE_INTERVAL = 300
export const DISTRIBUTION_HEIGTH = 40
export const MAP_DATA_APPEAR_FROM = 0.8
export const SLIDES_TRANSITION_TIME = 300
